import { Fragment } from 'react';
//===========import components================
import Header from 'partials/Header';
import Footer from 'partials/Footer';
import Button from 'components/common/Button';

const HomeLayout =
  (Component) =>
  ({ ...props }) => {
    return (
      <Fragment>
        <section
          className='homePageLayout z-10 flex flex-col justify-between relative lg:bg-transparent'
          style={{
            background: `url("/assets/gifs/homeGif.gif") no-repeat center/cover`,
          }}>
          <div className='overlay z-0'></div>
          <Header />
          <div className='homeBannerContent max-w-7xl mx-auto w-full flex flex-col pt-48 sm:pt-56 pb-16 sm:pb-24 px-6 md:px-8 2xl:px-0 relative'>
            <div className='heading relative pb-6'>
              <h3 className='font-medium text-eventYellow text-xl sm:text-3xl uppercase'>
                DE EVENTE
              </h3>
              <h1 className='font-bold text-white  text-2xl sm:text-4xl md:text-6xl uppercase'>
                we here. we listen.
                <br /> we respond.
              </h1>
            </div>
            <p className='text-white max-w-lg text-sm sm:text-lg pb-8 sm:pb-12'>
              It is a long established fact that a reader will be distracted by
              the readable content of a page when looking at its layout. The
              point of using Lorem Ipsum is that it has a more-or-less
            </p>
            <Button url='/contact-us' title='let’s Talk' />
          </div>
        </section>
        <Component {...props} />
        <Footer />
      </Fragment>
    );
  };

export default HomeLayout;
